import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/others/BreadCrumbs";
import GlobalStyles, { CommonClasses } from "../../global/GlobalStyles";
import { Link } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import api from "../../global/api";
import BigLoader from "../../components/loaders/BigLoader";

const breadcrumbItems = [
  { name: "Dashboard", path: "/admin/dashboard" },
  { name: "Manage shipping", path: "/admin/dashboard/manage-shipping" },
];

const ManageShipping = () => {
  const [shippingPackage, setShippingPackage] = useState([]);
  const [filteredPackages, setFilteredPackages] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const getShippingPackage = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/shipments`);
      setShippingPackage(response.data);
      setFilteredPackages(response.data); // Initialize filtered packages with all data
    } catch (error) {
      console.error("Error fetching shipments:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getShippingPackage();
    // eslint-disable-next-line
  }, []);

  // Filter shipments based on search term
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredPackages(shippingPackage);
    } else {
      const filtered = shippingPackage.filter(
        (item) =>
          item.tracking_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.sender_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.receiver_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.origin.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.destination.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredPackages(filtered);
    }
  }, [searchTerm, shippingPackage]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className={GlobalStyles.dashbooardPageContainer}>
      <div className={GlobalStyles.dashbooardPageWrap}>
        <div className={GlobalStyles.seperator}>
          <Breadcrumbs items={breadcrumbItems} />
          <Link to={`/ship`} className={GlobalStyles.button}>
            Create shipping
          </Link>
        </div>
        <div className={GlobalStyles.searchContainer}>
          <FaSearch className={GlobalStyles.searchIcon} />
          <input
            type="text"
            placeholder="Search by tracking ID, name, or location"
            className={GlobalStyles.searchInput}
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
        {loading ? (
          <div className="w-full flex justify-center py-40">
            <BigLoader />
          </div>
        ) : (
          <>
            <span className={GlobalStyles.textCount}>
              {filteredPackages.length}{" "}
              {filteredPackages.length === 1 ? "order" : "orders"} found
            </span>
            <div className="w-full flex flex-col gap-1">
              {filteredPackages.length > 0 ? (
                filteredPackages
                  .slice()
                  .reverse()
                  .map((item) => (
                    <div
                      key={item.tracking_id}
                      className={`w-full bg-light dark:bg-dark px-3 py-2 ${CommonClasses.transition} ${CommonClasses.rounded} flex justify-between items-center`}
                    >
                      <span className={GlobalStyles.textSecondary}>
                        {item.tracking_id}
                      </span>
                      <Link
                        className={GlobalStyles.button}
                        to={`/admin/dashboard/manage-shipping/${item.tracking_id}`}
                      >
                        View
                      </Link>
                    </div>
                  ))
              ) : (
                <div className={GlobalStyles.textCount}>
                  No shipments found.
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ManageShipping;
